export default "__VITE_ASSET__nh8ebDuR__"